import { render, staticRenderFns } from "./PalletsLogs.vue?vue&type=template&id=2bf8d1ce&scoped=true"
import script from "./PalletsLogs.vue?vue&type=script&lang=js"
export * from "./PalletsLogs.vue?vue&type=script&lang=js"
import style0 from "./PalletsLogs.vue?vue&type=style&index=0&id=2bf8d1ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf8d1ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
